import { merge } from '@fluentui/react';
export const metaVulnReportAttackScenario_Windows = {
    Unknown: {
        displayName: 'Unknown',
        order: 0,
    },
    Remote: {
        displayName: 'Remote',
        order: 1,
    },
    Remote_R1: {
        displayName: 'Unauthenticated non-sandboxed code execution with no user interaction',
        order: 2,
        groupName: 'Remote',
    },
    Remote_R2: {
        displayName: 'Demonstrated unauthorized access to private user data with little or no user interaction',
        order: 3,
        groupName: 'Remote',
    },
    Remote_R3: {
        displayName: 'Data destruction or persistent denial of service with no user interaction',
        order: 4,
        groupName: 'Remote',
    },
    Local: {
        displayName: 'Local',
        order: 20,
    },
    Local_L1: {
        displayName: 'Sandbox escape with little or no user interaction',
        order: 21,
        groupName: 'Local',
    },
    Local_L2: {
        displayName: 'Demonstrated unauthorized access to sensitive user data from a sandboxed process with no user interaction',
        order: 22,
        groupName: 'Local',
    },
};
export const metaVulnReportAttackScenario_TeamsDesktop = {
    RemoteCodeExecution_TeamsDesktop: {
        displayName: 'Remote code execution (native code in the context of the current user) with no user interaction',
        order: 30,
    },
    AuthenticationCredentials_TeamsDesktop: {
        displayName: 'Ability to obtain authentication credentials for other users (note: does not include phishing)',
        order: 35,
    },
    XSSNoUserInteraction_TeamsDesktop: {
        displayName: 'XSS or other (remote) code injection resulting in ability to execute arbitrary scripts in the context of teams.microsoft.com or teams.live.com with no user interaction',
        order: 40,
    },
    ElevationOfPrivilege_TeamsDesktop: {
        displayName: 'Elevation of privilege which traverses an operating system user boundary',
        order: 45,
    },
    XSSUserInteraction_TeamsDesktop: {
        displayName: 'XSS or other (remote) code injection resulting in ability to execute arbitrary scripts in the context of teams.microsoft.com or teams.live.com with minimal user interaction',
        order: 50,
    },
};
export const metaVulnReportAttackScenario_TeamsMobile = {
    RemoteCodeExecution_TeamsMobile: {
        displayName: 'Remote code execution (within application sandbox) with no user interaction',
        order: 55,
    },
    AuthenticationCredentials_TeamsMobile: {
        displayName: 'Ability to obtain authentication credentials for other users (note: does not include phishing)',
        order: 60,
    },
};
export const metaVulnReportAttackScenario_Dynamics365 = {
    CrossTenantInformationDisclosure_Dynamics365: {
        displayName: 'Cross-tenant information disclosure',
        order: 70,
    },
    Other_Dynamics365: {
        displayName: 'Other',
        order: 75,
    },
};
export const metaVulnReportAttackScenario = merge({}, metaVulnReportAttackScenario_Dynamics365, metaVulnReportAttackScenario_TeamsDesktop, metaVulnReportAttackScenario_TeamsMobile, metaVulnReportAttackScenario_Windows);
